var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", color: "primary", dark: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Quotation")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: {
                    elevation: "0",
                    color: "success",
                    disabled: !_vm.quotation?.id
                  },
                  on: { click: _vm.printPdf }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-printer")
                  ]),
                  _vm._v(" Print ")
                ],
                1
              ),
              _c(
                "v-chip",
                {
                  attrs: {
                    color: _vm.quotation?.is_locked ? "red" : "green",
                    small: "",
                    dark: ""
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.quotation?.is_locked ? "Locked" : "Open") +
                      " "
                  )
                ]
              )
            ],
            1
          ),
          _vm.quotation
            ? _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Subject:")]),
                        _c("div", [_vm._v(_vm._s(_vm.quotation?.subject))])
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Date:")]),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDateUS(
                                new Date(_vm.quotation?.actual_date)
                              )
                            )
                          )
                        ])
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Customer:")]),
                        _c("div", [
                          _vm._v(
                            " (" +
                              _vm._s(_vm.quotation?.customer?.id) +
                              ") " +
                              _vm._s(_vm.quotation?.customer?.name) +
                              " "
                          )
                        ])
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Project Code:")]),
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.quotation?.project_code?.code || "-") +
                              " "
                          ),
                          _vm.quotation?.project_code?.description
                            ? _c("small", [
                                _vm._v(
                                  " - " +
                                    _vm._s(
                                      _vm.quotation?.project_code.description
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("VAT Type:")]),
                        _c("div", [_vm._v(_vm._s(_vm.quotation?.vat_type))])
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Discount Rate:")]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.quotation?.discount_rate))
                        ])
                      ]),
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("strong", [_vm._v("Notes:")]),
                        _c("div", [_vm._v(_vm._s(_vm.quotation?.notes || "-"))])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c("h3", [_vm._v("Items")]),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.quotation?.items,
                      dense: "",
                      "disable-pagination": "",
                      "hide-default-footer": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.unit_price",
                          fn: function({ value }) {
                            return [
                              _vm._v(
                                " " + _vm._s(_vm.currencyFormat(value)) + " "
                              )
                            ]
                          }
                        },
                        {
                          key: "item.amount",
                          fn: function({ item }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currencyFormat(item.amount)) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: "item.specs",
                          fn: function({ item }) {
                            return [
                              _c("small", [
                                _vm._v(_vm._s(item.specs?.join(", ")))
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.is_service",
                          fn: function({ value }) {
                            return [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    small: "",
                                    color: value ? "green" : "red"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        value ? "mdi-check" : "mdi-close"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "body.append",
                          fn: function() {
                            return [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "5" }
                                  },
                                  [_vm._v("Sub Total")]
                                ),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.currencyFormat(
                                          _vm.quotation?.items_sub_total
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "5" }
                                  },
                                  [_vm._v("Discount")]
                                ),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.currencyFormat(
                                          _vm.quotation?.items_discount
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "5" }
                                  },
                                  [_vm._v("Total (vat ex)")]
                                ),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.currencyFormat(
                                          _vm.quotation?.items_total_vat_ex
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "5" }
                                  },
                                  [_vm._v("VAT")]
                                ),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.currencyFormat(
                                          _vm.quotation?.items_vat_amount
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "5" }
                                  },
                                  [_vm._v(" Total ")]
                                ),
                                _c("th", { staticClass: "text-right" }, [
                                  _c("strong", { staticClass: "text-h6" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.currencyFormat(
                                            _vm.quotation?.items_total_amount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3147459501
                    )
                  }),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c("h3", [_vm._v("Terms & Conditions")]),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.quotation?.terms_and_conditions, function(
                      value,
                      key
                    ) {
                      return _c(
                        "v-list-item",
                        { key: key },
                        [
                          _c("v-list-item-content", [
                            _c("strong", [_vm._v(_vm._s(key))]),
                            _c("div", [_vm._v(_vm._s(value))])
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }